import Cookies from 'js-cookie';
import { CODE_LITE_COOKIE_PREFIX } from '../constants';
export const getCookie = (name) => {
    return Cookies.get(name);
};
/**
 * 设置 cookie
 * @param name  cookie 名称
 * @param value cookie 值
 * @param options cookie 选项
 */
export const setCookie = (name, value, options) => {
    Cookies.set(name, value, Object.assign(Object.assign({}, options), { domain: '99digtech.com', path: '/' }));
};
/**
 * 删除 cookie
 * @param name  cookie 名称
 */
export const deleteCookie = (name) => {
    Cookies.remove(name, { domain: '99digtech.com', path: '/' });
};
/**
 * 设置 codeLite cookie
 * @param env 环境变量
 * @param data 数据
 */
export const setCodeLiteCookie = (env, data) => {
    // 根据 data 中的 key 设置 cookie
    Object.keys(data).forEach(key => {
        setCookie(`${env}_${CODE_LITE_COOKIE_PREFIX}${key}`, data[key] || '');
    });
};
/**
 * 删除 codeLite cookie
 * @param env 环境变量
 */
export const deleteCodeLiteCookie = (env) => {
    deleteCookie(`${env}_${CODE_LITE_COOKIE_PREFIX}auth`);
    deleteCookie(`${env}_${CODE_LITE_COOKIE_PREFIX}token`);
    deleteCookie(`${env}_${CODE_LITE_COOKIE_PREFIX}user`);
};
